export default __webpack_public_path__ + "static/Logo_Humero_Small_white-498a176507989dc3b5f70345d27d7179.png";